export const formatDuration = (totalSeconds: bigint): string => {
  const secs = Number(totalSeconds);
  if (secs <= 0) return '0m';

  const days = Math.floor(secs / 86400);
  const hours = Math.floor((secs % 86400) / 3600);
  const minutes = Math.floor((secs % 3600) / 60);

  const parts: string[] = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0 || parts.length === 0) parts.push(`${minutes}m`);
  return parts.join(' ');
};

export const getUptimeColor = (percentage: number): { bg: string; text: string; label: string } => {
  if (percentage >= 95) return { bg: 'bg-green-100', text: 'text-green-700', label: 'Excellent' };
  if (percentage >= 80) return { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Fair' };
  return { bg: 'bg-red-100', text: 'text-red-700', label: 'Poor' };
};
